import React from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

import Card from '@/components/common/Card';
import GrayButton from '@/components/common/elements/GrayButton';
import fileExport from '@/components/common/icons/file-export.svg';

const dateInputClass =
  'h-[35px] px-[10px] py-[6px] border-2 border-[#e3e3e3] rounded-[3px] bg-white text-[#393939] font-["Open_Sans"] text-sm leading-none focus:outline-none focus:border-[#4d8fca] transition-colors w-[184px]';

const ExportGeneralStatisticsComponent = ({
  isBusy,
  onClick,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  intl,
}) => (
  <div className="flex flex-col items-center justify-center h-[80%] pt-[1.5em] px-[1em]">
    <Card>
      <p className="max-w-[400px] mx-auto mb-[2em] text-center leading-none text-[#393939] font-['Open_Sans'] text-sm">
        {intl.formatMessage({ id: 'INSPECTOR_SPREADSHEET_GENERATE_MESSAGE' })}
      </p>
      <form className="flex flex-col items-center">
        <div className="flex justify-center mb-[1em]">
          <div className="flex flex-col justify-center items-start mr-[12px]">
            <label
              className="mb-[5px] text-[0.75em] font-semibold uppercase text-[#3c3c3c] font-['Open_Sans']"
              htmlFor="startDate"
            >
              {intl.formatMessage({ id: 'FROM_DAY' })}
            </label>
            <DatePicker
              id="startDate"
              name="startDate"
              placeholderText={intl.formatMessage({ id: 'INITIAL_DATE' })}
              className={dateInputClass}
              autoComplete="off"
              locale="pt-BR"
              dateFormat="dd 'de' MMMM 'de' yyy"
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              maxDate={new Date()}
              endDate={endDate}
              selected={startDate}
              popperPlacement="top-end"
            />
          </div>
          <div className="flex flex-col justify-center items-start">
            <label
              className="mb-[5px] text-[0.75em] font-semibold uppercase text-[#3c3c3c] font-['Open_Sans']"
              htmlFor="endDate"
            >
              {intl.formatMessage({ id: 'TO_DAY' })}
            </label>
            <DatePicker
              id="endDate"
              name="endDate"
              placeholderText={intl.formatMessage({ id: 'FINAL_DATE' })}
              className={dateInputClass}
              autoComplete="off"
              locale="pt-BR"
              dateFormat="dd 'de' MMMM 'de' yyy"
              onChange={handleEndDateChange}
              selectsEnd
              endDate={endDate}
              maxDate={new Date()}
              minDate={startDate}
              selected={endDate}
              popperPlacement="top-end"
            />
          </div>
        </div>
        <GrayButton onClick={onClick} isBusy={isBusy}>
          <img src={fileExport} alt={intl.formatMessage({ id: 'METRICS' })} className="!w-5 mr-2" />
          {intl.formatMessage({ id: 'REPORT_EXPORT' })}
        </GrayButton>
      </form>
    </Card>
  </div>
);

ExportGeneralStatisticsComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  isBusy: PropTypes.bool.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  handleStartDateChange: PropTypes.func.isRequired,
  handleEndDateChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

ExportGeneralStatisticsComponent.defaultProps = {
  startDate: null,
  endDate: null,
};

export default ExportGeneralStatisticsComponent;
